import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { SHARED_CONSTANT } from "../constant/shared.constant";
import { IN_GeneralReq, IN_PhoneReq, IN_VoterIdReq } from "../interface/shared.interface";

@Injectable({
  providedIn: "root",
})
export class SharedService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
    body: {},
  };

  constructor(private httpClient: HttpClient) {}

  public downloadFile() {
    return this.httpClient.get(SHARED_CONSTANT.DOWNLOAD_FILE);
  }

  public searchVisitor(visitorInfo) {
    return this.httpClient.get(
      `${SHARED_CONSTANT.VISITOR_SEARCH}/${visitorInfo}`
    );
  }

  public getCast() {
    return this.httpClient.get(`${SHARED_CONSTANT.CAST}`);
  }

  public searchByVoterId(payload: IN_VoterIdReq) {
    return this.httpClient.post(
      `${SHARED_CONSTANT.SEARCH_BY_VOTER_ID}`,
      payload
    );
  }

  public searchByPhone(payload: IN_PhoneReq) {
    return this.httpClient.post(`${SHARED_CONSTANT.SEARCH_BY_PHONE}`, payload);
  }

  public searchByGeneral(payload: IN_GeneralReq) {
    return this.httpClient.post(
      `${SHARED_CONSTANT.SEARCH_BY_GENERAL}`,
      payload
    );
  }

  public getSearchResultListConfig() {
    return this.httpClient.get(`${SHARED_CONSTANT.SEARCH_RESULT_TABLE_CONFIG}`);
  }

  public getAssemblyData() {
    return this.httpClient.get(`${SHARED_CONSTANT.ASSEMBLIES_LIST}`);
  }

  public getGaonData(assemblyId: any) {
    return this.httpClient.get(`${SHARED_CONSTANT.GAON_LIST}/${assemblyId}`);
  }
  public getGaonDataWithAssembly(assemblyId: any) {
    return this.httpClient.get(
      `${SHARED_CONSTANT.GAON_LIST_WITH_ASSEMBLY}/${assemblyId}`
    );
  }

  public getGatNumberData(gatId: any) {
    return this.httpClient.get(`${SHARED_CONSTANT.GATNO_LIST}/${gatId}`);
  }

  public getGanNumberData(ganId: any) {
    return this.httpClient.get(`${SHARED_CONSTANT.GAN_NUMBER_LIST}/${ganId}`);
  }

  public getPrabhagData(prabhagId: any) {
    return this.httpClient.get(`${SHARED_CONSTANT.PRABHAG_LIST}/${prabhagId}`);
  }

  public getPermissionData() {
    return this.httpClient.get(`${SHARED_CONSTANT.PERMISSION}`);
  }

  public getPrabhagAreaData(prabhagAreaId: any) {
    return this.httpClient.get(
      `${SHARED_CONSTANT.PRABHAG_AREA_LIST}/${prabhagAreaId}`
    );
  }
  // public getsubCastwithCast(castId: any) {
  //   return this.httpClient.get(
  //     `${SHARED_CONSTANT.SUBCAST_WITH_CAST}/${castId}`
  //   );
  // }

  public checkExistingNumber(obj){
    return this.httpClient.post(`${SHARED_CONSTANT.CHECK_EXISTING_NUMBER}`,obj)
  }
  public getAreaNagarList(){
    return this.httpClient.get(`${SHARED_CONSTANT.GET_AREA_NAGAR_LIST}`)
  }
  public getSocietyVastiList(){
    return this.httpClient.get(`${SHARED_CONSTANT.GET_SOCIETY_VASTI_LIST}`)
  }

}
